import { render, staticRenderFns } from "./CreateFAQForm.vue?vue&type=template&id=4c029ccb&scoped=true&"
import script from "./CreateFAQForm.vue?vue&type=script&lang=js&"
export * from "./CreateFAQForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c029ccb",
  null
  
)

export default component.exports